module.exports = __webpack_public_path__ + "img/homesol_7.1abd95e7.png";